export const LS_KEY_RIDDLE = 'Riddle';
export const SENT_VISIT = 'SendVisit';
export const SENT_STATS = 'SentStats';
export const LS_KEY_LANG = 'Lang';
export const REDEEMED_KEY = 'Redeemed';
export const LAST_PLAY_KEY = 'LastPlay';
export const GIFT_QR = 'X8P3QzT5fM3QzD9L9L4bC1a7bC1a72RwBgKXN2T5fMnY6';
export const BASE_URL = 'https://coralworldgame.cdigital.co.il/';

export const RESET_STORAGE_TIME = 16 * 60 * 60 * 1000; // 16 hours in milliseconds

export const STEPS = {
    HOME: 1,
    RIDDLE: 2,
    QUESTION: 3,
    FINISH: 4,
}